$(document).ready(function(){
  
   $(".faq-item").click(function(){
          var has_class = $(this).hasClass("show");
          $('.faq-item.show').find(".eam-faq-icon")
              .fadeTo(100,0.30, function() {
                  $(this)[0].src="//cdn.shopify.com/s/files/1/0084/5022/t/133/assets/eam-plus-icon.svg?v=85886259056727206611660858607";
              })
              .fadeTo(100,1);
          $(".faq-item").removeClass("show");
          if(!has_class){
              $(this).addClass("show");
              $(this).find(".faq-answer").slideDown(300);
              $($(this).find(".eam-faq-icon")[0])
              .fadeTo(100,0.30, function() {
                  $(this)[0].src="//cdn.shopify.com/s/files/1/0084/5022/t/133/assets/eam-minus-icon.svg?v=85886259056727206611660858607";
              })
              .fadeTo(100,1);
          }
          $(".faq-item:not(.show) .faq-answer").slideUp(300);
  });

  $('a.eam-button').on('click',function(e){
    e.preventDefault();
    if($(this).hasClass('eam-button-checkout')){
      
    }else{
      $('button.add_to_cart.global-button.ajax-submit').click();
    }
  });

  $('.eam-product-form-description-readmore').on('click',function(){
    if(!$(this).parent().find('.eam-tab-content-data-container').hasClass('eam-show-description-full')){
      $(this).parent().find('.eam-tab-content-data-container').addClass('eam-show-description-full');
      $(this).text('Read Less');
      $(this).addClass('eam-readmore-active');
    }else{
      $(this).parent().find('.eam-tab-content-data-container').removeClass('eam-show-description-full');
      $(this).text('Read More');
      $(this).removeClass('eam-readmore-active');
    }
  });
  $('.swatch label').on('click',function(){
    if($(this).parent().hasClass('color')){
       var color=$(this).parent().data('value');
       $('.product-variant-option-name').text(color);
    }
   eam_button_update();
  });
  function eam_button_update(){
    setTimeout(function(){
      if($('button.add_to_cart.ajax-submit').hasClass('disabled')){
        $('.eam-button:not(".eam-button-checkout")').addClass('eam-outofstock-button');
        $('.eam-product-review-content-stock-paragraph').text('Out of Stock');
        $('.eam-sticky-cta-left-content-review-image-1 p').text('Out of Stock');
        $('.eam-sticky-cta-left-content-review-image-1 img')[0].src='https://cdn.shopify.com/s/files/1/0084/5022/files/eam-red-dot.png?v=1661817166';
        $('img.eam-product-review-content-stock-image')[0].src='https://cdn.shopify.com/s/files/1/0084/5022/files/eam-red-dot.png?v=1661817166';
      }else{
        $('.eam-button:not(".eam-button-checkout")').removeClass('eam-outofstock-button');
        $('.eam-product-review-content-stock-paragraph').text('In Stock');
        $('.eam-sticky-cta-left-content-review-image-1 p').text('In Stock');
        $('.eam-sticky-cta-left-content-review-image-1 img')[0].src='https://cdn.shopify.com/s/files/1/0084/5022/files/Ellipse_238_small.png?v=1661381945';
        $('img.eam-product-review-content-stock-image')[0].src='https://cdn.shopify.com/s/files/1/0084/5022/files/Ellipse_238_small.png?v=1661381945';
      }
      var b_text=$('button.add_to_cart.ajax-submit').text();
      $('.eam-button:not(".eam-button-checkout")').text(b_text);
      
    },300);
  }

  
  
  eam_button_update();

 

});


    eam_update_color_name();
setTimeout(function(){    
  $('.spr-summary-actions-togglereviews').click();
 },1500);
function eam_update_color_name(){
   setTimeout(function(){
    if($('.product-variant-option-name').length>=1){
       var color=$('.swatch_options input:checked+.swatch-element.color').data('value');
       $('.product-variant-option-name').text(color);
    }
   },1000);
}
  
  const isElementInView = function (el) {
    if($(el).length>0){
      let pageTop = $(window).scrollTop();
      let pageBottom = pageTop + $(window).height();
      let elTop = $(el).offset().top;
      let elBottom = elTop + $(el).height();
      return ((elTop <= pageBottom) && (elBottom >= pageTop));      
    }

  }

  const hideStickyCTA = function() {
    $(".eam-sticky-cta-container").hide(300);
  }

  const showStickyCTA = function() {
    $(".eam-sticky-cta-container").show(300);
  }
  
    window.onscroll = function() {
      if (isElementInView(".product-container")) {
        if(window.innerWidth>768){
          hideStickyCTA();
          
        }else{
          showStickyCTA();
        }
      }
      else if (isElementInView(".footer")) {
        hideStickyCTA();
      }
      else {
        showStickyCTA();
      }
    }

$(document).ready(function(){
  
})
  // if(window.innerWidth<768){
  //   $('.eam-hiw-steps-container').flickity();
  // }
